import { render, staticRenderFns } from "./mario.vue?vue&type=template&id=1ccd5dd4&scoped=true"
var script = {}
import style0 from "./mario.vue?vue&type=style&index=0&id=1ccd5dd4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ccd5dd4",
  null
  
)

export default component.exports